export const tiers = [
  {
    tier: 'S',
    items: [
      { name: 'Raycast', url: 'https://raycast.com' },
      { name: 'Ghostty', url: 'https://ghostty.org' },
      { name: 'Tailscale', url: 'https://tailscale.com' },
      { name: 'Njalla', url: 'https://njal.la' },
      { name: 'Cloudflare', url: 'https://cloudflare.com' },
    ],
  },
  {
    tier: 'A',
    items: [
      { name: 'Zed', url: 'https://zed.dev' },
      { name: 'JetBrains', url: 'https://www.jetbrains.com' },
      { name: 'Mullvad', url: 'https://mullvad.net' },
      { name: 'Proton', url: 'https://proton.me' },
      { name: 'Zen', url: 'https://zen-browser.app' },
    ],
  },
  {
    tier: 'B',
    items: [
      { name: 'fish', url: 'https://fishshell.com' },
      { name: 'Starship', url: 'https://starship.rs' },
      { name: 'tmux', url: 'https://github.com/tmux/tmux' },
      { name: 'Superwhisper', url: 'https://superwhisper.com' },
    ],
  },
  {
    tier: 'F',
    items: [
      { name: 'MkDocs', url: 'https://www.mkdocs.org', note: 'The maintainer beef made me leave' },
    ],
  },
  {
    tier: 'Z',
    items: [
      { name: 'Obsidian', url: 'https://obsidian.md', note: 'Moved to Notion for better collaboration' },
      { name: 'Huly', url: 'https://huly.io', note: 'Switched to Linear' },
      { name: 'Make', url: 'https://www.gnu.org/software/make/', note: 'Replaced by just' },
      { name: 'Firefox', url: 'https://firefox.com', note: 'Switched to Zen' },
      { name: 'Arc', url: 'https://arc.net', note: 'Switched to Zen' },
      { name: 'Zellij', url: 'https://zellij.dev', note: 'Replaced by tmux' },
    ],
  },
];
